import React, { useEffect, useRef, useState } from 'react';
import { Empty, Form, message, Select, Tabs, TreeSelect } from '@drip/drip-design';
import IconTip from '@/components/icon-tip';
import ActivityTable
  from '@/pages/mvp-panel/participant-data/pages/activity-participation-effect/components/activity-table';


export default function (props) {
  return (
    <div className="participant-data-card-bg">
      <div className="activity-participation-effect-sub-title">
        已报活动列表
        <IconTip title="全年已参与的活动日历，包含正在参与和历史参与过的活动。一期仅支持主题活动（从2022年618开始）。活动历史数据最长保留365天。" />
      </div>
      <ActivityTable gotoDetail={props.gotoDetail} />
    </div>
  );
}
